import React, { useState } from "react";
import { BsExclamationTriangleFill } from "react-icons/bs";

const NotificationAlert = ({ title, notification }) => {
  const [showModal, setShowModal] = useState(true);
  return (
    <>
      {showModal ? (
        <div className="flex items-center justify-between bg-red-600 my-2 w-[98vw] rounded-xl min-h-min">
          <div className="w-full z-50">
            <div className=" text-white text-center p-2 rounded-lg">
              <div className="flex  flex-col justify-center items-center">
                <div className="flex items-center">
                <BsExclamationTriangleFill className=" text-lyellow" />
                &nbsp;
                <h2 className="font-extrabold  text-lyellow tracking-wide capitalize">{title}</h2>
                  </div>
                <div className="flex items-center">
                
                &nbsp;
                  <p className="text-sm font-semibold">{notification} </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <button
              className="text-white text-center p-2 rounded-lg mx-5 font-bold"
              onClick={() => setShowModal(false)}
            >
              X
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default NotificationAlert;
